import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type PolicyDetails } from '~entities/policies/index';

import { baseAPI } from '~shared/api/base-api';

interface DeletePolicyParams {
  policyId: string;
}

export const deletePolicyAPI = async (params: DeletePolicyParams) => {
  const response = await baseAPI.delete<PolicyDetails>(
    `/policies/${params.policyId}`,
  );
  return response.data;
};

export const useDeletePolicy = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: DeletePolicyParams) => deletePolicyAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['policies'] });
    },
  });
};
